import type React from 'react';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import PlayerButton from 'components/buttons/PlayerButton';
import StandardButton from 'components/buttons/StandardButton';
import TMXDialog, { type TMXDialogProps } from 'components/dialogs/TMXDialog';
import Participant from 'components/participants/Participant';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

import { useStyles } from './styles';

interface PenaltyParticipantsDialogProps extends TMXDialogProps {
  participants?: ParticipantInterface[];
  onParticipantSelect?: (participant: ParticipantInterface) => void;
}

const PenaltyParticipantsDialog: React.FC<React.PropsWithChildren<PenaltyParticipantsDialogProps>> = ({
  participants,
  onParticipantSelect,
  ...props
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const handleCloseClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (typeof props.onClose === 'function') {
      props.onClose(e, 'escapeKeyDown');
    }
  };
  return (
    <TMXDialog
      {...props}
      className={classes.tmxDialog}
      PaperProps={{ elevation: 0, className: classes.participantsDialog }}
    >
      <div className={classes.participantsDialogHeader}>
        <Typography className={classes.dialogTitle} variant="h2">
          {t('suspensionPoints')}
        </Typography>
        <Typography className={classes.dialogSubtitle}>{t('choosePlayerDialogText')}</Typography>
      </div>
      <DialogContent className={classes.participantsDialogContent}>
        {(participants || []).map((participant, ind) => (
          <PlayerButton key={ind} onClick={() => onParticipantSelect(participant)}>
            <Participant participantId={participant?.participantId} showAdditionalInfo={true} />
          </PlayerButton>
        ))}
      </DialogContent>
      <DialogActions className={classes.participantsDialogActions}>
        <StandardButton onClick={handleCloseClick}>{t('Close')}</StandardButton>
      </DialogActions>
    </TMXDialog>
  );
};

export default PenaltyParticipantsDialog;
